export function FileIcon({ ext }) {
  const map = {
    pdf: "PDF",
    doc: "DOC",
    docx: "DOC",
    jpg: "IMG",
    jpeg: "IMG",
    png: "IMG",
    gif: "IMG",
    webp: "IMG",
    xls: "XLS",
    xlsx: "XLS",
    mp4: "VID",
  };

  return (
    <div
      style={{
        width: 42,
        height: 46,
        borderRadius: 9,
        background: "#F7FAFB",
        border: "1px solid #DCE6EB",
        display: "grid",
        placeItems: "center",
        flexShrink: 0,
      }}
    >
      <span style={{ fontSize: 9, fontWeight: 900, color: "#64748B" }}>
        {(map[ext] || ext || "ARQ").toUpperCase().slice(0, 3)}
      </span>
    </div>
  );
}
